export default __webpack_public_path__ + "static/media/BumpFund_Icons_03.bfbed0bb.svg";